export default "__VITE_ASSET__vp7zjQRy__"